import { render, staticRenderFns } from "./CustosFixosVariaveisNoCustoTotalPercentual.vue?vue&type=template&id=98244a5c&scoped=true&"
import script from "./CustosFixosVariaveisNoCustoTotalPercentual.vue?vue&type=script&lang=js&"
export * from "./CustosFixosVariaveisNoCustoTotalPercentual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98244a5c",
  null
  
)

export default component.exports